import { render, staticRenderFns } from "./NoIcon.vue?vue&type=template&id=5dad0169&scoped=true"
import script from "./NoIcon.vue?vue&type=script&lang=ts"
export * from "./NoIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dad0169",
  null
  
)

export default component.exports